import { memo } from "react";
import { TableProps } from "antd";
import { Table } from "../../../../../../components";
import { DateHelper } from "../../../../../../helper";

export const CoursesTable = memo(
  ({ dataSource: rawDataSource = [], ...restProps }: TableProps<any>) => {
    const dataSource = rawDataSource.map((e, index) => {
      const eTrainees = !e.eTrainees
        ? []
        : e.eTrainees.map((e: any) => `${e.label}(${e.value})`).join(",");
      const eCoursePlaces = !e.eCoursePlaces
        ? []
        : e.eCoursePlaces.map((e: any) => `${e.label}(${e.value})`).join(",");
      const eLessonTypes = !e.eLessonTypes
        ? []
        : e.eLessonTypes.map((e: any) => `${e.label}(${e.value})`).join(",");
      return {
        ...e,
        stt: index + 1,
        eDateTime: DateHelper.formatRangeDateToString(e.eDateTime, {
          symbol: "|",
        }),
        eTrainees,
        eCoursePlaces,
        eLessonTypes,
        eTrainingCount: e?.eTrainees?.length
          ? e.eTrainees.reduce(
              (total: number, current: any) => total + current.value,
              0
            )
          : "",
      };
    });

    return (
      <Table dataSource={dataSource} scroll={{ x: 2000 }} {...restProps} />
    );
  }
);
